import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Button, TextField, Typography, useMediaQuery } from '@mui/material';

export default function TopicEditor({ createMode, onCancel, onSave, saving, topic }) {
  const [title, setTitle] = useState(topic.title);
  const [description, setDescription] = useState(topic.description);
  const isMobile = useMediaQuery('(max-width:600px)');

  const handleSave = () => {
    onSave?.({
      id: topic.topicId,
      name: title.trim(),
      description: description?.trim(),
    });
  };

  return (
    <Box sx={{ maxWidth: '800px', mx: 'auto', py: 4, px: 2 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        {createMode ?
          <FormattedMessage id="helpCenter.topic.create" /> :
          <FormattedMessage id="helpCenter.topic.edit" />
        }
      </Typography>

      <TextField
        label="Rubrik"
        fullWidth
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        sx={{ mb: 2 }}
      />

      <TextField
        label="Ingress"
        fullWidth
        value={description || ""}
        onChange={(e) => setDescription(e.target.value)}
        sx={{ mb: 2 }}
      />

      <Box sx={{ display: 'flex', gap: 2, flexDirection: isMobile ? 'column' : 'row' }}>
        <Button variant="contained" onClick={handleSave} disabled={saving}>
          <FormattedMessage id="btn.save" />
        </Button>
        <Button variant="outlined" onClick={onCancel} disabled={saving}>
          <FormattedMessage id="btn.cancel" />
        </Button>
      </Box>
    </Box>
  );
}
